import {getBoolRegistration} from '../utils/firebase-config';
import React, {useState, useEffect} from 'react';
import TourneyRegistrationTable from '../components/tourney_registration_table';
import TourneyOngoingTable from '../components/tourney_ongoing_table';
import '../css/tournament.css';

function TourneyPage() {
  const [registrationbool, setRegistrationBool] = useState(false);

  const checkopenregistration = async() => {
    var isopen = await getBoolRegistration()
    setRegistrationBool(isopen)
  }

  useEffect(() => {
    checkopenregistration();
  }, [])

  function DisplayRegistration(props) {
    const rs = props.registrationopen
    if(rs == false){
        return (
            <><p>no tournaments available for registration</p></>
        )
    }if(rs == true){
        return (
          <>
            <h4>Tournament Registration</h4>
            <TourneyRegistrationTable></TourneyRegistrationTable>
          </>
          
        )
    }else{
        return(<></>)
    }
  }
    return (
        <>
        <br></br>
        <DisplayRegistration registrationopen={registrationbool}/>
        <hr />
        <h4>Ongoing Tournaments</h4>
        <TourneyOngoingTable></TourneyOngoingTable>
        <br></br>
        </>
    )
    }
    
export default TourneyPage